module.exports = __webpack_public_path__ + "static/wand_of_binding-6dfe13b328690eb03d81301ac6cdb18e.jpeg";